<template>

  <div>
    <!--企业列表-->
    <Supply v-if="activeName == 'supply'"></Supply>
       <!--企业分类-->

       <Category v-if="activeName == 'category'&& code=='kuajingyun'"></Category>

       <DynamicComment v-if="activeName == 'dynamicComment' "></DynamicComment>
    <!--单位类别-->
    <Grade v-if="activeName == 'grade'"></Grade>
    <!--企业设置-->
    <Setting v-if="activeName == 'setting'"></Setting>
     <!--企业详情-->
    <Detail v-if="activeName == 'detail'"></Detail>

     <Zhaoshang v-if="activeName == 'zhaoshang'"></Zhaoshang>

    <Park v-if="activeName == 'park'"></Park>

    <Qualification v-if="activeName == 'qualification'"></Qualification>

    <Product v-if="activeName == 'product'"></Product>

    <Index v-if="activeName == 'index'"></Index>
    <Menu v-if="activeName == 'menu'"></Menu>
    <ProjectCategory v-if="activeName == 'project_category'"></ProjectCategory>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Supply from './supply/index';
import SupplyApi from '@/api/supply.js';
import Qualification from './qualification/index';
import Setting from './setting/getSetting.vue';
import Grade from './grade/index';
import Category from './category/index';
import Detail from './detail/index';
import Zhaoshang from './zhaoshang/index';
import Product from './product/index';
import Park from './park/index';
import Index from '../project_investment/index/index';
import ProjectCategory from '../project_investment/category/index.vue';
import Menu from '../project_investment/menu/index.vue';

import DynamicComment from './dynamic_comment/index';

export default {
  components: {
    Supply,
    Index,
    ProjectCategory,
    Menu,
    Setting,
    Zhaoshang,
    Qualification,
    Grade,
    Category,
    Detail,
    Product,
    Park,
    DynamicComment,

  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      isuse:0,
      /*当前选中*/
      activeName: 'supply',
      code:this.$route.query.code,
      /*切换数组*/
      sourceList: [
        {
          key: 'supply',
          value: '企业列表',
          path:'/plus/supply/supply/index'
        },
        //  {
        //   key: 'detail',
        //   value: '企业详情',
        //   path:'/plus/supply/detail/index'
        // },
           {
          key: 'dynamicComment',
          value: '评论',
          path:'/plus/supply/dynamic_comment/index'
        },
        //    {
        //   key: 'product',
        //   value: '产品',
        //   path:'/plus/supply/product/index'
        // },
        //    {
        //   key: 'qualification',
        //   value: '企业资质',
        //   path:'/plus/supply/qualification/index'
        // },
        // {
        //   key: 'zhaoshang',
        //   value: '招商',
        //   path:'/plus/supply/zhaoshang/index'
        // },
        //  {
        //   key: 'park',
        //   value: '政府园区',
        //   path:'/plus/supply/park/index'
        // },
        {
          key: 'category',
          value: '行业分类',
          path:'/plus/supply/category/index'
        },
        {
          key: 'grade',
          value: '单位类别',
          path:'/plus/supply/grade/index'
        },

        //   {
        //   key: 'project_category',
        //   value: '项目投资分类',
        //   path:'/plus/project_investment/category/index'
        // },
        //     {
        //   key: 'menu',
        //   value: '项目投资类目',
        //   path:'/plus/project_investment/menu/index'
        // },

      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {
    this.getInas({},function(res){
                self.isuse = res
            })
    this.init();
    this.updateRead()

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'supply',list: [] });
    bus.$off('activeValue');
  },
  methods: {
     updateRead(){
      if(this.code == 'shanghui'){
 SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'10'
      }).then(res=>{
      })
       SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'19'
      }).then(res=>{
      })
      }


      if(this.code =='company'){
          SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'12'
      }).then(res=>{
      })
        SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'18'
      }).then(res=>{
      })
      }
       if(this.code =='government'){
         SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'20'
      }).then(res=>{
      })
       }
       if(this.code =='kuajingyun'){
         SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'21'
      }).then(res=>{
      })
       }

    },
    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'supply'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter() {
      var list = []; 
      for (var i = 0; i < this.sourceList.length; i++) {
        var item = this.sourceList[i];
        
        var hasAuth = false;
        if (this.$filter && typeof this.$filter.isAuth === 'function') {
          hasAuth = this.$filter.isAuth(item.path);
        }
        if (!hasAuth) {
          continue;
        }

        // 2. 仅当code为kuajingyun时，才显示行业分类标签
        if (item.key === 'category' && this.code !== 'kuajingyun') {
          continue;
        }

        // 符合条件的标签加入列表
        list.push(item);
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/index.vue